import React from 'react';

export function CardPriceComponent({price, loading}) {
    if (price && price.shortLabel) {
        const {perNight, shortLabel} = price;

        return (
            <span className="CommonRatioCard__price">
                <span className={'CommonRatioCard__price__amount'}>
                    {loading ? '···' : shortLabel}
                </span>{' '}
                {perNight}
            </span>
        );
    }
    return null;
}

export default CardPriceComponent;
